import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import { useTranslation } from 'react-i18next';
import { UtilityProofFileSchema } from '../../types/utility-proof.type';

export interface UtilityFileListProps {
  files: UtilityProofFileSchema[];
}

const UtilityFileList: React.FC<UtilityFileListProps> = ({ files }) => {
  const { t } = useTranslation();

  if (files.length === 0) {
    return (
      <Typography variant="caption" color="text.disabled" sx={{ fontStyle: 'italic' }}>
        {t('dataEntry.proofs.noFiles')}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {files.map((file) => {
        const uploadedLabel = t('dataEntry.proofs.uploadedOn', {
          date: new Date(file.created_at).toLocaleDateString(),
        });
        if (file.download_url) {
          return (
            <Chip
              key={file.id}
              icon={<AttachFileOutlinedIcon />}
              label={file.original_name}
              size="small"
              variant="outlined"
              component="a"
              href={file.download_url}
              target="_blank"
              rel="noopener noreferrer"
              clickable
              title={uploadedLabel}
              sx={{
                maxWidth: 240,
                fontSize: '0.75rem',
                '& .MuiChip-label': {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'block',
                  maxWidth: 190,
                },
              }}
            />
          );
        }
        return (
          <Chip
            key={file.id}
            icon={<AttachFileOutlinedIcon />}
            label={file.original_name}
            size="small"
            variant="outlined"
            title={uploadedLabel}
            sx={{
              maxWidth: 240,
              fontSize: '0.75rem',
              opacity: 0.85,
              '& .MuiChip-label': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block',
                maxWidth: 190,
              },
            }}
          />
        );
      })}
    </Box>
  );
};

export default UtilityFileList;
